// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hXyK","buttons":"styles_buttons__2uRz0"};